export default "__VITE_ASSET__4b01b663__"